export const FulfillmentStatus = {
  ORDER_PLACED: 'ORDER_PLACED',
  PRODUCTION_STARTED: 'PRODUCTION_STARTED',
  PRODUCTION_DELAYED: 'PRODUCTION_DELAYED',
  FEEDBACK_RECEIVED: 'FEEDBACK_RECEIVED',

  PRODUCTION_COMPLETE: 'PRODUCTION_COMPLETE',
  RECEIVED_BY_CARRIER: 'RECEIVED_BY_CARRIER',
  IN_TRANSIT: 'IN_TRANSIT',
  OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
  DELIVERY_DELAYED: 'DELIVERY_DELAYED',
  REPLACEMENT_ISSUED: 'REPLACEMENT_ISSUED',

  DELIVERY_ATTEMPTED: 'DELIVERY_ATTEMPTED',

  DELIVERED: 'DELIVERED',
  EXCEPTION: 'EXCEPTION',
  INCOMPLETE: 'INCOMPLETE',
  RETURNED_TO_SENDER: 'RETURNED_TO_SENDER',
  UNKNOWN: 'UNKNOWN',
} as const

export type FulfillmentStatusType = (typeof FulfillmentStatus)[keyof typeof FulfillmentStatus]

export const errorStatuses: FulfillmentStatusType[] = [
  FulfillmentStatus.EXCEPTION,
  FulfillmentStatus.INCOMPLETE,
  FulfillmentStatus.PRODUCTION_DELAYED,
  FulfillmentStatus.RETURNED_TO_SENDER,
]

export const warningStatuses: FulfillmentStatusType[] = [FulfillmentStatus.DELIVERY_DELAYED, FulfillmentStatus.DELIVERY_ATTEMPTED]

export type FulfillmentLevel = 'error' | 'warning' | 'success'

export const getFulfillmentStatusLevel = (status: FulfillmentStatusType): FulfillmentLevel => {
  if (errorStatuses.includes(status)) {
    return 'error'
  }

  if (warningStatuses.includes(status)) {
    return 'warning'
  }

  return 'success'
}
